function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 96,
  height: 96,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_9_260)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.5384 76C16.0013 76 14.6939 75.4612 13.6163 74.3837C12.5388 73.3061 12 71.9987 12 70.4616V25.5384C12 24.0013 12.5388 22.6939 13.6163 21.6163C14.6939 20.5388 16.0013 20 17.5384 20H78.4616C79.9987 20 81.3061 20.5388 82.3837 21.6163C83.4612 22.6939 84 24.0013 84 25.5384V70.4616C84 71.9987 83.4612 73.3061 82.3837 74.3837C81.3061 75.4612 79.9987 76 78.4616 76H17.5384ZM17.5384 72.9231H78.4616C79.0769 72.9231 79.641 72.6667 80.1539 72.1539C80.6667 71.641 80.9231 71.0769 80.9231 70.4616V25.5384C80.9231 24.9231 80.6667 24.359 80.1539 23.8461C79.641 23.3333 79.0769 23.0769 78.4616 23.0769H17.5384C16.9231 23.0769 16.359 23.3333 15.8461 23.8461C15.3333 24.359 15.0769 24.9231 15.0769 25.5384V70.4616C15.0769 71.0769 15.3333 71.641 15.8461 72.1539C16.359 72.6667 16.9231 72.9231 17.5384 72.9231ZM29.8538 44H66.7846L55.6231 28.9461L44.6769 42.8077L37.5538 33.9846L29.8538 44Z",
  fill: "#1C1B1F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.7999 51.6386H46.5308V61.7462L42.0807 57.3155L40.5 58.8962L47.5845 66L54.7499 58.977L53.1499 57.377L48.7999 61.7462V51.6386Z",
  fill: "#1C1B1F"
}));

function SvgDownloadImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_260",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadImg1);
export default __webpack_public_path__ + "static/media/download_img_1.54effa17.svg";
export { ForwardRef as ReactComponent };